
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Mail, Clock, ArrowDown } from "lucide-react";

const EmailSequence: React.FC = () => {
  const emails = [
    {
      id: 1,
      subject: "Welcome to SaunaDip! Your listing is live",
      description: "Introduction to your new operator account with next steps to complete your profile.",
      day: "Day 1",
      icon: <Mail />,
    },
    {
      id: 2,
      subject: "5 tips to boost your sauna visibility",
      description: "Learn how to optimize your listing with photos, descriptions, and service details.",
      day: "Day 3",
      icon: <Mail />,
    },
    {
      id: 3,
      subject: "See how other operators are succeeding",
      description: "Case studies and examples from top-performing sauna and plunge businesses.",
      day: "Day 7",
      icon: <Mail />,
    },
    {
      id: 4,
      subject: "Your trial ends soon - keep the momentum going",
      description: "Reminder about trial ending with benefits of continuing as a premium operator.",
      day: "Day 12",
      icon: <Mail />,
    }
  ];

  return (
    <div className="max-w-3xl mx-auto">
      <p className="text-center text-lg text-gray-600 mb-8">
        Our thoughtfully designed email sequence guides you through the onboarding process,
        helping you maximize your presence on SaunaDip.
      </p>
      
      <div className="relative">
        {emails.map((email, index) => (
          <React.Fragment key={email.id}>
            <div className="relative z-10 flex items-start gap-4">
              <div className="shrink-0 flex flex-col items-center">
                <div className="w-12 h-12 rounded-full bg-sauna-blue flex items-center justify-center text-white">
                  {email.icon}
                </div>
                <div className="text-xs font-medium text-sauna-blue mt-1">{email.day}</div>
                {index < emails.length - 1 && (
                  <div className="h-16 w-0.5 bg-gray-200 my-2"></div>
                )}
              </div>
              
              <Card className="flex-1 mb-8">
                <CardContent className="p-5">
                  <h4 className="font-semibold mb-2">{email.subject}</h4>
                  <p className="text-gray-600 text-sm">{email.description}</p>
                  
                  <div className="flex items-center gap-2 mt-4 text-xs text-gray-500">
                    <Clock size={14} />
                    <span>Sent automatically on {email.day}</span>
                  </div>
                </CardContent>
              </Card>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default EmailSequence;
